module.exports = __webpack_public_path__ + "assets/75aa89dbe30dd053a9ceb30d4e2b8917.svg";